import { CardContent, Link } from '@mui/material';
import { MinimalCard } from 'components/styled';

import { Typography, Grid, AboutIcon, Spacer } from './styles';

import { ExternalLink, Facebook, Instagram, Twitter } from 'react-feather';

function Elsewhere() {
  return (
    <MinimalCard $hoverEffect={false} sx={{ mb: 6 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Elsewhere
        </Typography>

        <Spacer mb={4} />

        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid size="auto">
            <AboutIcon>
              <ExternalLink />
            </AboutIcon>
          </Grid>
          <Grid size="auto">
            <Link href="https://material-app.bootlab.io/">lucylavender.io</Link>
          </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid size="auto">
            <AboutIcon>
              <Twitter />
            </AboutIcon>
          </Grid>
          <Grid size="auto">
            <Link href="https://material-app.bootlab.io/">Twitter</Link>
          </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid size="auto">
            <AboutIcon>
              <Facebook />
            </AboutIcon>
          </Grid>
          <Grid size="auto">
            <Link href="https://material-app.bootlab.io/">Facebook</Link>
          </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center">
          <Grid size="auto">
            <AboutIcon>
              <Instagram />
            </AboutIcon>
          </Grid>
          <Grid size="auto">
            <Link href="https://material-app.bootlab.io/">Instagram</Link>
          </Grid>
        </Grid>
      </CardContent>
    </MinimalCard>
  );
}

export default Elsewhere;
